import { PolicySuggestion } from '../../types';

export const pickDisplayedSuggestion = (
  suggestions: PolicySuggestion[],
  currentId: string | null
): PolicySuggestion | null => {
  const pending = suggestions.filter(s => s.status === 'pending');
  if (currentId) {
    const pinned = pending.find(s => s.id === currentId);
    if (pinned) {
      return pinned;
    }
  }
  return pending[0] ?? null;
};
